export function formatPersonName(...parts: Array<string | null | undefined>) {
  return parts
    .filter((part): part is string => Boolean(part?.trim()))
    .map(part => part.trim())
    .join(" ")
    .replace(
      /(^|[\s'-])(\p{L})/gu,
      (_match, separator, letter) => `${separator}${letter.toUpperCase()}`,
    );
}

export function getWorkerProfilePath(worker: {
  id: number;
  name: string;
  lastname?: string | null;
}) {
  const slug = [worker.name, worker.lastname]
    .filter(Boolean)
    .join(" ")
    .trim()
    .toLowerCase()
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");

  if (!slug) {
    throw new Error("Worker name is required to build a public profile URL");
  }

  return `/worker/${slug}-${worker.id}`;
}

export function parseWorkerProfileSlug(value: string) {
  const match = value.match(/^([a-z0-9]+(?:-[a-z0-9]+)*)-(\d+)$/);
  return match ? { slug: match[1], id: Number(match[2]) } : null;
}
